import React from 'react';
import { IconChevronRight } from '@tabler/icons-react';

export function CellDetailTriggerChevron() {
    return (
        <IconChevronRight
            size={18}
            stroke={2.25}
            className="shrink-0 text-gray-500"
            aria-hidden
        />
    );
}
